// @ts-nocheck
/**
 * One-step onboarding for Academy Settings when opened with ?tour=true (not the Admin+ drawer tour).
 * @param {object} vm - Vue component instance with $t
 */
export function buildAcademySettingsTourSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="1"]',
      label: t("message.onboarding_academy_settings_label"),
      title: t("message.onboarding_academy_settings_title"),
      autoClick: true,
      icon: require("@/assets/icons/admin+/academy-settings.svg"),
      description: t("message.onboarding_academy_settings_description"),
      before() {
        const element = document.querySelector('[data-v-step="1"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
